'use client';

import type { IllustrationSlotName } from '@/components/features/campaigns';
import { IllustrationSlot } from '@/components/entities/IllustrationSlot/IllustrationSlot';
import { useIllustration } from '@/components/features/campaigns';
import { cn } from '@/utils/cn';

type EmptyStateSlot = Extract<IllustrationSlotName, 'emptyState' | 'emptyFavorites'>;

type EmptyStateVisualProps = {
  className?: string;
  isCompactSize?: boolean;
  alt?: string;
  slot?: EmptyStateSlot;
};

const EmptyStateVisual = ({
  className,
  isCompactSize = false,
  alt = '',
  slot = 'emptyState',
}: EmptyStateVisualProps) => {
  const slotName = slot === 'emptyState' && isCompactSize ? 'emptyStateCompact' : slot;
  const illustration = useIllustration(slotName);
  const hasOwnGlow = illustration?.type === 'layers';

  return (
    <div className={cn('relative', className)}>
      {!hasOwnGlow && (
        <div
          className={cn(
            'absolute left-11.25 rounded-full blur-[1.71875rem] pointer-events-none bg-main-back-gradient',
            isCompactSize ? 'top-8 size-15.25' : 'top-7.75 size-25.75',
          )}
        />
      )}
      <IllustrationSlot
        slot={slotName}
        alt={alt}
        className={cn('h-auto relative block', isCompactSize ? 'w-38' : 'w-50.5')}
      />
    </div>
  );
};

export default EmptyStateVisual;
